import uiI18n from "../i18n";
import { publicListings, listingById, saveListing } from './listingService';
export const getAllBiens = () => publicListings('Biens');
export const getAllByCity = (city) => publicListings('Biens/GetBienByCity/' + encodeURIComponent(city));
export const getBienById = (id) => listingById('Biens', id);
const search = (route, page, filters = {}) => {
  const query = new URLSearchParams({ page: page || 0 });
  Object.entries(filters).forEach(([key,value]) => {
    if (value !== '' && value != null) query.set(key, Array.isArray(value) ? value.join(',') : value);
  });
  return publicListings('Biens/' + route + '?' + query);
};
export const getOffers = (page, filters) => search('getOffers', page, filters);
export const getRents = (page, filters) => search('getRents', page, filters);
export const getSales = (page, filters) => search('getSales', page, filters);
export const getBiens = (page, filters) => search('getBiensCity', page, filters);
export const createBien = (data, files) => saveListing('Biens', data, files);
export const updateBien = (data, files) => saveListing('Biens', data, files, true);
export const createVacation = (data, files) => saveListing('Vacation', data, files);
export const updateVacation = (data, files) => saveListing('Vacation', data, files, true);
export const updateVacationOld = updateVacation;
export const saveFile = async () => { throw new Error(uiI18n.t("ui.add_photos_to_the_listing_form_before_saving")); };
